<template>
  <div class="text-center">
    <v-dialog v-model="confirmPaymentDialog" persistent width="500">
      <v-form
        ref="form"
        :action="payment.ncaa_payment.url"
        method="post"
        @submit="closeConfirmPaymentDialog"
      >
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>
            {{ isPaymentLoaded ? "Continue to Payment?" : "Please wait" }}
          </v-card-title>

          <v-divider />

          <v-card-text :class="padTop">
            <div v-if="!isPaymentLoaded">
              <v-progress-circular
                indeterminate
                class="mr-1"
                color="primary"
                :size="20"
                :width="3"
              />
              Gathering payment information...
            </div>
            <div v-else>
              By clicking Continue, you will be redirected to our payment site
              to make a payment for {{ service.year }} pertaining to service
              <span :class="emphasize">{{ service.name }}</span
              >.
              <div v-for="(value, key) in filteredPaymentFields" :key="key">
                <input type="hidden" :name="key" :value="value" />
              </div>
            </div>
          </v-card-text>

          <v-divider />

          <v-card-actions>
            <v-btn text @click="closeConfirmPaymentDialog">Cancel</v-btn>
            <v-spacer />
            <v-btn color="success" type="submit" :disabled="!isPaymentLoaded">
              Continue
              <v-icon right>$vuetify.icons.externalLink</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { getServicePayment } from "../api/servicePayment.api";
import HttpStatus from "http-status";

export default {
  name: "PaymentConfirm",
  data() {
    return {
      isPaymentLoaded: false,
      showFormFields: false,
      payment: {
        ncaa_payment: {
          id: 0,
          amount: 0,
          status: "",
          invoice_number: "",
          hash_sequence: "",
          hash_timestamp: "",
          hash_value: "",
          authorization_code: "",
          transaction_id: "",
          response_code: "",
          response_reason_code: "",
          response_reason_text: "",
          response_received_at: "",
          vendor_login_id: "",
          vendor_url: "",
          created_at: "",
          updated_at: "",
          history: [],
        },
        servicer: {},
      },
    };
  },
  methods: {
    ...mapActions("service", ["addServicePaymentToService"]),
    ...mapActions("servicePayment", ["closeConfirmPaymentDialog"]),
    resetPayment() {
      this.isPaymentLoaded = false;
    },
    startPayment() {
      this.resetPayment();

      getServicePayment(this.service.id)
        .then((response) => {
          if (response.status === HttpStatus.OK) {
            this.isPaymentLoaded = true;
            this.payment = response.data;

            if (this.isServicerPayingFromApplicationList) {
              this.addServicePaymentToService(this.payment.service_payment);
            }
          }
        })
        .catch((error) => {
          this.closeConfirmPaymentDialog();
          if (error.response.data.message) {
            this.$notify.error(error.response.data.message);
          } else {
            this.$notify.error(
              "An error occurred while getting payment information."
            );
          }
        });
    },
    openPaymentUrl() {
      if (this.isPaymentLoaded && this.payment.ncaa_payment.href) {
        window.open(this.payment.ncaa_payment.href, "_blank");
        this.closeConfirmPaymentDialog();
      }
    },
  },
  computed: {
    ...mapState("servicePayment", ["confirmPaymentDialog", "service"]),
    emphasize() {
      return "font-weight-black";
    },
    padTop() {
      return "pt-5";
    },
    isServicerPayingFromApplicationList() {
      return this.$router.currentRoute.path.endsWith("/applications");
    },
    filteredPaymentFields() {
      const excludedFields = ["id", "url"];
      const filtered = {};

      if (this.payment && this.payment.ncaa_payment) {
        Object.keys(this.payment.ncaa_payment).forEach((key) => {
          if (!excludedFields.includes(key)) {
            filtered[key] = this.payment.ncaa_payment[key];
          }
        });
      }

      return filtered;
    },
  },
  watch: {
    confirmPaymentDialog(val) {
      if (val) {
        this.startPayment();
      }
    },
  },
};
</script>
